<template>
	<span v-tooltip="options" ref="tooltip" class="persistent-tooltip"></span>
</template>
<script>
	export default {
		name: 'PersistentTooltip',
		props: ['content', 'placement', 'tipclassname', 'buttonclassname'],
		data: function () {
			return {
				options: {
					placement: this.placement || 'right', // side (+ '-' + 'start'/'end')
					content: this.content || '<p>&nbsp;</p>',
					trigger: 'click',
					template: '' +
							'<div class="' + (this.tipclassname || 'tooltip') +'" role="tooltip">' +
								'<div class="tooltip-arrow"></div>' +
								'<span class="tooltip-close btn btnSm ' + (this.buttonclassname || 'btnRed') + '" id="persistent-tooltip__' + this._uid + '">OK, got it</span>' +
								'<div class="tooltip-inner"></div>' +
							'</div>',
					container: 'body'
				}
			};
		},
		methods: {
			handleCloseClick: function (e) {
				if (e.target && e.target.matches('#persistent-tooltip__' + this._uid)) {
					this.$refs.tooltip.click();
					this.$emit('remove');
				}
			}
		},
		mounted: function () {
			this.$refs.tooltip.click();
			document.body.addEventListener('click', this.handleCloseClick);
		},
		destroyed: function () {
			document.body.removeEventListener('click', this.handleCloseClick);
		}
	}
</script>
